import axios from "axios";
export default {
  // medicines
  // diseases
  // governorates
  // cities
  // organizations
  // categories
  // families
  // diseases
  // doctors
  // products

  async fetchList({ commit }, credentials) {
    let response;
    try {
      response = await axios.get(
        `dropdown/${credentials.endpointName}?page=${credentials.page}&governorate_id=${credentials.govId}&term=${credentials.term}`
      );
      if (response.status == 200) {
        commit("SET_SUCCESS", true);
        commit(credentials.mutationName, response.data.data);
      } else {
        commit("SET_SUCCESS", false);
      }
    } catch (e) {
      commit("SET_ERROR_MESSAGE", e.response.data.message);
      commit("SET_ERRORS", e.response.data.errors);
    }
  },
};
